<!-- Header -->
<header class="mb-6 flex flex-wrap items-center gap-x-6 gap-y-4">
  <div class="flex min-w-0 flex-1 items-center gap-4">
    @if (isLoadingClient() && !client()) {
    <div class="size-14 shrink-0 animate-pulse rounded-full bg-gray-200 dark:bg-gray-800"></div>
    <div class="h-6 w-48 animate-pulse rounded bg-gray-200 dark:bg-gray-800"></div>
    } @else {
    <span class="pp-avatar" aria-hidden="true">{{ initials() }}</span>
    <div class="min-w-0">
      <h2 class="truncate text-xl font-semibold text-gray-900 sm:text-2xl dark:text-white">{{ fullName() || 'Cliente' }}</h2>
      <p class="text-theme-sm text-gray-500 dark:text-gray-400">
        @if (firstVisit(); as first) {
        Cliente desde {{ first.start | date: 'MMMM y' }}
        } @else if (client()?.createdAt) {
        Registrado el {{ client()!.createdAt! | date: 'd MMM y' }}
        } @else {
        Sin visitas todavía
        }
      </p>
    </div>
    }
  </div>
  <div class="flex flex-wrap gap-2">
    @if (whatsappUrl(); as wa) {
    <a [href]="wa" target="_blank" rel="noopener" class="pp-btn pp-btn--ghost">
      <svg class="size-4 text-[#16a34a]" fill="currentColor" viewBox="0 0 24 24" aria-hidden="true">
        <path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347m-5.421 7.403h-.004a9.87 9.87 0 01-5.031-1.378l-.361-.214-3.741.982.998-3.648-.235-.374a9.86 9.86 0 01-1.51-5.26c.001-5.45 4.436-9.884 9.888-9.884 2.64 0 5.122 1.03 6.988 2.898a9.825 9.825 0 012.893 6.994c-.003 5.45-4.437 9.884-9.885 9.884m8.413-18.297A11.815 11.815 0 0012.05 0C5.495 0 .16 5.335.157 11.892c0 2.096.547 4.142 1.588 5.945L.057 24l6.305-1.654a11.882 11.882 0 005.683 1.448h.005c6.554 0 11.89-5.335 11.893-11.893a11.821 11.821 0 00-3.48-8.413Z" />
      </svg>
      WhatsApp
    </a>
    }
    @if (client()?.phone) {
    <a [href]="'tel:' + client()!.phone" class="pp-btn pp-btn--ghost">
      <svg class="size-4" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">
        <path d="M22 16.92v3a2 2 0 01-2.18 2 19.79 19.79 0 01-8.63-3.07 19.5 19.5 0 01-6-6A19.79 19.79 0 012.12 4.18 2 2 0 014.11 2h3a2 2 0 012 1.72c.13.96.36 1.9.7 2.81a2 2 0 01-.45 2.11L8.09 9.91a16 16 0 006 6l1.27-1.27a2 2 0 012.11-.45c.91.34 1.85.57 2.81.7A2 2 0 0122 16.92z" />
      </svg>
      Llamar
    </a>
    }
    <button type="button" class="pp-btn pp-btn--ghost" (click)="onEditClient()">
      <svg class="size-4" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">
        <path d="M12 20h9M16.5 3.5a2.12 2.12 0 013 3L7 19l-4 1 1-4 12.5-12.5z" />
      </svg>
      Editar datos
    </button>
  </div>
</header>

<div class="grid items-start gap-6 lg:grid-cols-[minmax(0,1fr)_340px]">

  <!-- ── Main column ── -->
  <div class="min-w-0 space-y-6">

    <!-- Next appointment / return reminder -->
    @if (nextVisit(); as next) {
    <div class="pp-next">
      <div class="pp-next__date" aria-hidden="true">
        <span class="text-theme-xs font-medium uppercase">{{ next.start | date: 'MMM' }}</span>
        <span class="text-2xl font-bold leading-none">{{ next.start | date: 'd' }}</span>
      </div>
      <div class="min-w-0 flex-1">
        <p class="text-theme-xs font-medium text-brand-600 dark:text-brand-300">Próxima cita, {{ relativeDays(next.start) }}</p>
        <p class="truncate text-base font-semibold text-gray-900 dark:text-white">{{ next.serviceName }}</p>
        <p class="text-theme-sm text-gray-600 dark:text-gray-300">
          {{ next.start | date: "EEEE d 'de' MMMM, h:mm a" }}
          @if (next.professionalName) { con {{ next.professionalName }} }
        </p>
      </div>
      @if (upcoming().length > 1) {
      <button type="button" class="pp-link shrink-0" (click)="openVisits('upcoming')">
        {{ upcoming().length - 1 }} más
      </button>
      }
    </div>
    } @else if (isOverdue()) {
    <div class="pp-reminder">
      <p class="text-theme-sm text-gray-700 dark:text-gray-200">
        Suele volver cada {{ visitEveryDays() }} días y su última visita fue {{ relativeDays(lastVisit()!.start) }}.
        No tiene citas agendadas.
      </p>
      @if (whatsappUrl(); as wa) {
      <a [href]="wa" target="_blank" rel="noopener" class="pp-btn pp-btn--primary shrink-0">Escribirle por WhatsApp</a>
      }
    </div>
    }

    <!-- Visits summary -->
    <section class="cp-card" aria-labelledby="pp-visits-title">
      <div class="flex flex-wrap items-baseline justify-between gap-x-4 gap-y-1">
        <h2 id="pp-visits-title" class="cp-card__title">Visitas</h2>
        @if (visits().length) {
        <button type="button" class="pp-link" (click)="openVisits('past')">Ver historial completo</button>
        }
      </div>

      @if (isLoadingEvents() && !visits().length) {
      <div class="mt-5 grid grid-cols-2 gap-4 sm:grid-cols-4">
        @for (_ of [1, 2, 3, 4]; track $index) {
        <div class="h-12 animate-pulse rounded-lg bg-gray-100 dark:bg-white/[0.05]"></div>
        }
      </div>
      } @else if (eventsFailed()) {
      <p class="mt-4 text-theme-sm text-gray-600 dark:text-gray-300">
        No pudimos cargar sus citas.
        <button type="button" class="pp-link" (click)="loadEvents(userId!)">Reintentar</button>
      </p>
      } @else if (!pastVisits().length && !upcoming().length) {
      <p class="mt-4 text-theme-sm text-gray-500 dark:text-gray-400">
        Todavía no ha venido. Cuando agendes su primera cita, aquí verás cada cuánto vuelve y qué servicios prefiere.
      </p>
      } @else {
      <dl class="pp-facts mt-5">
        <div>
          <dt>Visitas</dt>
          <dd>{{ pastVisits().length }}</dd>
        </div>
        <div>
          <dt>Última visita</dt>
          <dd>{{ lastVisit() ? relativeDays(lastVisit()!.start) : 'Ninguna' }}</dd>
        </div>
        <div>
          <dt>Suele venir</dt>
          <dd>{{ visitEveryDays() ? 'cada ' + visitEveryDays() + ' días' : 'Sin datos aún' }}</dd>
        </div>
        <div>
          <dt>Servicio habitual</dt>
          <dd class="truncate" [title]="favoriteService()?.name ?? ''">{{ favoriteService()?.name ?? 'Sin datos aún' }}</dd>
        </div>
      </dl>

      <!-- 12-month rhythm -->
      <figure class="mt-6" [attr.aria-label]="visitsLastYear() + ' visitas en los últimos 12 meses'">
        <div class="pp-rhythm" aria-hidden="true">
          @for (m of rhythm(); track m.key) {
          <div class="pp-rhythm__col" [title]="(m.date | date: 'MMMM y') + ': ' + m.count + (m.count === 1 ? ' visita' : ' visitas')">
            <div class="pp-rhythm__track">
              @if (m.count) {
              <span class="pp-rhythm__bar" [style.height.%]="m.height"></span>
              }
            </div>
            <span class="pp-rhythm__label">{{ m.date | date: 'MMM' }}</span>
          </div>
          }
        </div>
        <figcaption class="mt-2 text-theme-xs text-gray-500 dark:text-gray-400">
          {{ visitsLastYear() }} {{ visitsLastYear() === 1 ? 'visita' : 'visitas' }} en los últimos 12 meses{{ favoriteProfessional() ? ', casi siempre con ' + favoriteProfessional()!.name : '' }}.
        </figcaption>
      </figure>

      @if (recentVisits().length) {
      <h3 class="mt-6 text-theme-sm font-medium text-gray-700 dark:text-gray-300">Últimas visitas</h3>
      <ul class="mt-2 divide-y divide-gray-100 dark:divide-gray-800">
        @for (v of recentVisits(); track v.eventId) {
        <li class="flex items-center gap-4 py-3">
          <span class="pp-day" aria-hidden="true">
            <span>{{ v.start | date: 'd' }}</span>
            <small>{{ v.start | date: 'MMM' }}</small>
          </span>
          <div class="min-w-0 flex-1">
            <p class="truncate text-theme-sm font-medium text-gray-800 dark:text-white/90">{{ v.serviceName }}</p>
            <p class="truncate text-theme-xs text-gray-500 dark:text-gray-400">
              {{ v.start | date: "d 'de' MMMM y" }}@if (v.professionalName) {, con {{ v.professionalName }}}
            </p>
          </div>
          <span class="pp-status" [attr.data-tone]="statusTone(v.statusCode)">{{ v.statusName }}</span>
        </li>
        }
      </ul>
      @if (pastVisits().length > recentVisits().length) {
      <button type="button" class="pp-link mt-1" (click)="openVisits('past')">
        Ver las {{ pastVisits().length }} visitas
      </button>
      }
      }
      }
    </section>

    <app-client-payment-history [clientId]="client()?.userId ?? null" [events]="rawEvents()"></app-client-payment-history>
  </div>

  <!-- ── Side column ── -->
  <aside class="space-y-6">
    <app-client-credit [clientId]="client()?.userId ?? null" [clientName]="fullName()"></app-client-credit>

    <section class="cp-card" aria-labelledby="pp-contact-title">
      <h2 id="pp-contact-title" class="cp-card__title">Datos de contacto</h2>
      <dl class="pp-contact mt-4">
        <div>
          <dt>Teléfono</dt>
          <dd>{{ client()?.phone || 'Sin teléfono' }}</dd>
        </div>
        <div>
          <dt>Correo</dt>
          <dd>
            @if (client()?.email) {
            <a [href]="'mailto:' + client()!.email" class="pp-link break-all">{{ client()!.email }}</a>
            } @else { Sin correo }
          </dd>
        </div>
        <div>
          <dt>País</dt>
          <dd>{{ client()?.countryName || 'Sin país' }}</dd>
        </div>
      </dl>
    </section>
  </aside>
</div>

<!-- Full visit history -->
<dialog #visitsDialog class="cp-dialog cp-dialog--wide" aria-labelledby="pp-history-title"
  (click)="onDialogClick($event, visitsDialog)">
  <div class="cp-dialog__body">
    <div class="flex items-start justify-between gap-4">
      <div>
        <h2 id="pp-history-title" class="text-lg font-semibold text-gray-900 dark:text-white">Historial de citas</h2>
        <p class="mt-0.5 text-theme-sm text-gray-500 dark:text-gray-400">{{ fullName() }}</p>
      </div>
      <button type="button" class="pp-close" (click)="closeVisits()" aria-label="Cerrar">
        <svg class="size-5" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" aria-hidden="true"><path d="M6 6l12 12M18 6L6 18" /></svg>
      </button>
    </div>

    <div class="mt-4 flex flex-wrap gap-2" role="group" aria-label="Filtrar citas">
      @for (opt of filterOptions; track opt.value) {
      <button type="button" class="pp-chip" [attr.aria-pressed]="filter() === opt.value" (click)="setFilter(opt.value)">
        {{ opt.label }} <span class="tabular-nums opacity-70">{{ filterCounts()[opt.value] }}</span>
      </button>
      }
    </div>

    <label class="sr-only" for="pp-search">Buscar por servicio o profesional</label>
    <input id="pp-search" type="search" class="pp-search mt-3" placeholder="Buscar por servicio o profesional"
      [value]="search()" (input)="search.set($any($event.target).value); dialogLimit.set(30)" />

    <div class="mt-3 max-h-[58vh] overflow-y-auto pr-1">
      @for (group of dialogGroups(); track group.label) {
      <h3 class="pp-month">{{ group.label }}</h3>
      <ul class="divide-y divide-gray-100 dark:divide-gray-800">
        @for (v of group.visits; track v.eventId) {
        <li class="flex items-start gap-4 py-3">
          <span class="pp-day" aria-hidden="true">
            <span>{{ v.start | date: 'd' }}</span>
            <small>{{ v.start | date: 'EEE' }}</small>
          </span>
          <div class="min-w-0 flex-1">
            <p class="text-theme-sm font-medium text-gray-800 dark:text-white/90">{{ v.serviceName }}</p>
            <p class="text-theme-xs text-gray-500 dark:text-gray-400">
              {{ v.start | date: 'h:mm a' }}@if (v.professionalName) {, con {{ v.professionalName }}}@if (v.price) {, {{ formatMoney(v.price) }}}
            </p>
            @if (v.notes) {
            <p class="mt-1 text-theme-xs italic text-gray-500 dark:text-gray-400">{{ v.notes }}</p>
            }
          </div>
          <div class="flex shrink-0 flex-col items-end gap-1">
            <span class="pp-status" [attr.data-tone]="statusTone(v.statusCode)">{{ v.statusName }}</span>
            @if (v.statusCode !== 'cancelled' && v.start < now()) {
            <span class="text-theme-xs" [class.text-success-600]="v.paymentCompleted" [class.text-gray-400]="!v.paymentCompleted">
              {{ v.paymentCompleted ? 'Pagada' : 'Sin pagar' }}
            </span>
            }
          </div>
        </li>
        }
      </ul>
      } @empty {
      <p class="py-8 text-center text-theme-sm text-gray-500 dark:text-gray-400">
        @if (search()) { Ninguna cita coincide con “{{ search() }}”. } @else { No hay citas en esta lista. }
      </p>
      }
      @if (dialogTotal() > dialogLimit()) {
      <button type="button" class="pp-btn pp-btn--ghost mt-3 w-full" (click)="showMoreVisits()">
        Mostrar más ({{ dialogTotal() - dialogLimit() }} restantes)
      </button>
      }
    </div>
  </div>
</dialog>

<app-modal [open]="open" [title]="'Editar cliente'" [size]="'md'" [bodyComponent]="PeopleEditForm"
  [closeOnBackdrop]="false" [bodyInputs]="modalInputs" (confirm)="onModalConfirm($event)" (close)="open = false"
  [isSaving]="isSaving">
</app-modal>
